<template>
  <div
    id="c-tariff-card"
    class="flex flex-col h-full border-solid border border-light rounded"
  >
    <div
      class="bg-gray font-bold min-h-[7rem] text-center text-2xl flex justify-center items-center"
    >
      {{ tariff.name }}
    </div>
    <div
      class="text-sm h-full flex flex-col px-2xs py-xs justify-between max-mobile:text-base"
    >
      <ul class="m-0">
        <li
          class="list-image-[url('/images/dbc-tick.svg')]"
          v-for="condition in tariff.descriptionJson?.conditions"
        >
          {{ condition }}
        </li>
      </ul>
      <p v-for="note in tariff.descriptionJson?.notes">
        {{ note }}
      </p>
      <div
        class="flex flex-col justify-end text-center gap-2xs mt-2xs"
        v-if="!hideButtons"
      >
        <NuxtLink
          :href="getPagePath['priceList']![locale]"
          target="_blank"
          :class="buttonSecondarySpecial"
          >{{ $t('dbc-text-further-tariffdetails') }}
        </NuxtLink>
        <button
          v-if="!isTariffSelected"
          :class="buttonPrimary"
          @click="onSelect"
        >
          {{ $t('dbc-btn-choose-tariff') }}
        </button>
        <RegistrationSuccessTick
          v-if="isTariffSelected"
        ></RegistrationSuccessTick>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  tariff: Tariff
  hideButtons?: boolean | null
}>()

const emit = defineEmits<{
  (e: 'onSelect', tariff: Tariff): void
}>()

const { locale } = useI18n()

const route = useRoute()
const router = useRouter()

const isTariffSelected = inject('isTariffSelected', false)

async function onSelect() {
  const registrationPath =
    getPagePath[isWebview() ? 'embedded-register' : 'register']![locale.value]
  if (route.path !== registrationPath) {
    router.push({
      path: registrationPath,
      query: { tariff: props.tariff.id },
    })
  } else {
    emit('onSelect', props.tariff)
  }
}
</script>
